import React from "react";
import { observer } from "mobx-react";
import Events from ".";

function EventDetail() {
    return <Events component="detail" />
}

export default observer(EventDetail);